// extracted by mini-css-extract-plugin
export default {"heading":"_1FISZtoMnwDbmLR3SJxWQB","actionList":"xmSadMV3MI7N5OjMGt0rs","actionItem":"_3qtdPT9jeavCKJjyhfcJFk"};